import i18nRaw from 'i18next';
import { initReactI18next } from 'react-i18next';

// react-i18next v12 + i18next v15 infer t() as
// `string | object | (string | object)[] | undefined`, which React 18's
// stricter HTMLAttributes.children rejects. Re-export the i18n instance
// with a narrowed `t` signature so inline `i18n.t(...)` calls compile.
type StrictI18n = Omit<typeof i18nRaw, 't'> & {
    t: (key: string | string[], defaultValueOrOptions?: string | object, options?: object) => string;
};
const i18n = i18nRaw as unknown as StrictI18n;

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/ru'; // As new languages are added they must be imported for moment.js

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        interpolation: { escapeValue: false },
        fallbackLng: 'en',
        ns: ['common', 'validation'], // New namespaces need to be added here so they will be loaded
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        react: {
            useSuspense: false,
            bindI18n: 'languageChanged loaded',
            bindI18nStore: 'added removed',
            nsMode: 'default',
        },
        detection: {
            order: ['localStorage', 'cookie', 'navigator'],
            lookupLocalStorage: 'i18nlocale',
        },
    });

i18n.on('languageChanged', lng => {
    moment.locale(lng);
});

export default i18n;
